import * as Joi from "joi";
import { GenPartial } from 'typeormgen';
import { TableDisplayable } from '../decorators';
import { DEPARTMENTS } from '../enums/enums';

@TableDisplayable('getName')
export default class Department {
	id: DEPARTMENTS;
	name: string;
	abbrev: string;
	color: string;
	permType:
		| 'cmPermission'
		| 'haPermission'
		| 'muPermission'
		| 'setPermission'
		| 'prPermission';

	static rules() {
		return {
			id: Joi.number().integer(),
		};
	}

	toJSON() {
		return {
			id: this.id,
			name: this.name,
			abbrev: this.abbrev,
			color: this.color,
			permType: this.permType,
		};
	}

	constructor(props?: GenPartial<Department>) {
		Object.assign(this, props);
	}

	getName() {
		return this.name;
	}

	isInventory() {
		return (
			this.id === DEPARTMENTS.CM ||
			this.id === DEPARTMENTS.PR ||
			this.id === DEPARTMENTS.SET
		);
	}
}
